import React from 'react'
import Events from './Events'
import Groupe from './Groupe'

const Evening = ({ evening }) => {
  return (
    <div>
      <h4>
        {evening.title} - {evening.place} - {evening.time}
      </h4>
      {evening.events && (
        <div>
          <Events events={evening.events} />
        </div>
      )}
      <div className="jour-groupes">
        {evening.groups.map(({ nom, description, artistes, image, video, links }, i) => (
          <Groupe
            key={i}
            nom={nom}
            description={description}
            artistes={artistes}
            image={image}
            video={video}
            links={links}
          />
        ))}
      </div>
    </div>
  )
}

export default Evening
